import apiClient from "@services/api/apiClient.jsx";

/**
 * 페이지 디자인 테마 관련 API 서비스
 */
const themeApi = {
    /**
     * 모든 테마 목록 조회
     * @returns {Promise<Array>} 테마 목록
     */
    getAllThemes: async () => {
        try {
            const response = await apiClient.get("/designs/themes");
            return response.data;
        } catch (error) {
            console.error("테마 목록 조회 실패:", error);
            throw error;
        }
    },

    /**
     * 활성화된 테마 목록 조회
     * @returns {Promise<Array>} 활성화 된 테마 목록
     */
    getActiveThemes: async () => {
        try {
            const response = await apiClient.get("/designs/themes/active");
            return response.data;
        } catch (error) {
            console.error("활성화 테마 목록 조회 실패:", error);
            throw error;
        }
    },

    /**
     * 특정 테마 조회
     * @param {number} themeId 테마 ID
     * @returns {Promise<Object>} 테마 정보
     */
    getTheme: async (themeId) => {
        try {
            const response = await apiClient.get(`/designs/themes/${themeId}`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId} 조회 실패:`, error);
            throw error;
        }
    },

    /**
     * 테마 생성
     * @param {Object} themeData 테마 데이터
     * @returns {Promise<Object>} 생성된 테마 정보
     */
    createTheme: async (themeData) => {
        try {
            const response = await apiClient.post("/designs/themes", themeData);
            return response.data;
        } catch (error) {
            console.error("테마 생성 실패:", error);
            throw error;
        }
    },

    /**
     * 테마 수정
     * @param {number} themeId 테마 ID
     * @param {Object} themeData 테마 데이터
     * @returns {Promise<Object>} 수정된 테마 정보
     */
    updateTheme: async (themeId, themeData) => {
        try {
            const response = await apiClient.put(`/designs/themes/${themeId}`, themeData);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId} 수정 실패:`, error);
            throw error;
        }
    },

    /**
     * 테마 삭제
     * @param {number} themeId 테마 ID
     * @returns {Promise<void>}
     */
    deleteTheme: async (themeId) => {
        try {
            await apiClient.delete(`/designs/themes/${themeId}`);
        } catch (error) {
            console.error(`테마 ID ${themeId} 삭제 실패:`, error);
            throw error;
        }
    },

    /**
     * 테마 활성화/비활성화 토글
     * @param {number} themeId 테마 ID
     * @param {boolean} isActive 활성화 여부
     * @returns {Promise<Object>} 수정된 테마 정보
     */
    toggleThemeActivation: async (themeId, isActive) => {
        try {
            const response = await apiClient.patch(`/designs/themes/${themeId}/active?isActive=${isActive}`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId} 활성화 상태 변경 실패:`, error);
            throw error;
        }
    },

    /**
     * 테마 배포
     * @param {number} themeId 테마 ID
     * @param {number} branchId 지점 ID
     * @returns {Promise<Object>} 수정된 테마 정보
     */
    deployTheme: async (themeId, branchId) => {
        try {
            const response = await apiClient.patch(`/designs/themes/${themeId}/branches/${branchId}/deploy`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId} 지점 ID ${branchId} 배포 실패:`, error);
            throw error;
        }
    },

    /**
     * 테마 배포 취소
     * @param {number} themeId 테마 ID
     * @param {number} branchId 지점 ID
     * @returns {Promise<Object>} 수정된 테마 정보
     */
    undeployTheme: async (themeId, branchId) => {
        try {
            const response = await apiClient.patch(`/designs/themes/${themeId}/branches/${branchId}/undeploy`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId} 지점 ID ${branchId} 배포 취소 실패:`, error);
            throw error;
        }
    }

    //디자인
};

export default themeApi;